import { CUSTOMER_EXTERNAL_REFERENCE_KEY } from "../constants.js";
export const getCustomerSaltoId = (customer) => {
    return customer?.externalReferences?.find((ref) => ref.key === CUSTOMER_EXTERNAL_REFERENCE_KEY.SALTO_CUSTOMER_ID)?.value;
};
